<template>
    <div>
        <b-modal id="edit-custom-doc-file" title="Edit file" scrollable hide-footer>
            <!-- we can add If users want to change some value here later -->
            <div class="form-group">
                <label for="path">File</label>
                <input type="file" class="form-control" id="file" @change="selectedFile" />
                <div class="newUserButtonContainer">
                    <b-button @click="closeModal('edit-custom-doc-file')">Cancel</b-button>
                    <b-button @click="saveCustomDoc">Edit</b-button>
                </div>
            </div>
        </b-modal>
    </div>
</template>

<style scoped>
.newUserButtonContainer {
    display: flex;
    justify-content: space-between;
}
</style>

<script>
import Vue from 'vue'
// resources
import CustomDocResource from '../../resources/custom_doc'
// mixins
import modalMixin from '../../mixins/modal'
import toastMixin from '../../mixins/toast'

export default Vue.extend({
    props: {
        resource: {
            required: false,
            type: Object,
            default: () => {
                return null
            },
        },
    },
    data() {
        return {
            file: '',
            customDocResource: null,
            isSaving: false,
        }
    },
    mixins: [modalMixin, toastMixin],
    methods: {
        selectedFile() {
            let fileData = document.getElementById('file').files[0]
            this.getBase64(fileData)
                .then((encodedFile) => (this.file = encodedFile))
                .catch((err) => this.createToast('b-toaster-top-center', 'danger', true, 'File Upload Error', err))
        },
        getBase64(file) {
            return new Promise((resolve, reject) => {
                const fileReader = new FileReader()
                fileReader.readAsDataURL(file)
                fileReader.onload = () => {
                    resolve(fileReader.result)
                }
                fileReader.onerror = (error) => {
                    reject(error)
                }
            })
        },
        async saveCustomDoc() {
            this.resource.set('path', this.file)
            let errors = this.resource.validate()

            if (errors.length) {
                this.handleErrors(errors)
            } else {
                try {
                    this.isSaving = true
                    const result = await this.resource.save()
                    if (result.response.status === 200 || result.response.status === 201) {
                        this.createToast('b-toaster-top-center', 'success', true, 'Custom Document Edited', '')
                        this.closeModal('edit-custom-doc-file')
                    }
                } catch (error) {
                    this.createToast('b-toaster-top-center', 'danger', true, 'Custom Document Edit Error', 'Error')
                    throw error
                }
                this.isSaving = false
            }
        },
    },
    computed: {
        resources() {
            return {
                CustomDocResource,
            }
        },
    },
})
</script>
